<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑敏感词' : '新增敏感词'"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="关键词" prop="words" :error="errors.words">
                        <el-input v-model="form.words"></el-input>
                    </el-form-item>
                    <el-form-item label="级别" prop="level.value" :error="errors.level" v-if="$root.isAdmin">
                        <RemoteSelect v-model="form.level.value" :url="'/dict/list/public/level'" @change="changeLevel"></RemoteSelect>
                    </el-form-item>
                  <el-form-item label="业务" prop="code" :error="errors.code" v-if="$root.isAdmin">
                    <Cascade v-model="form.code"></Cascade>
                  </el-form-item>
                    <el-form-item label="备注" prop="remark" :error="errors.remark">
                        <el-input v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'
    import Cascade from '@/components/Cascade'

    export default {
        components: {
          RemoteSelect,
          Cascade,
        },
        data() {
            return {
                form: {
                    id: this.$route.params.id,
                    words: "",
                    level: {value: 'customer'},
                    remark: "",
                    code: this.$root.code
                },
                rules: {
                    words: [
                        {required: true, message: "请填写关键词"},
                    ],
                    "level.value": [
                        {required: true, message: "请选择级别"}
                    ],
                },
                errors: {}
            }
        },
        beforeMount() {
            if (this.form.id > 0) {
                this.$axios.get("/sensitives/get/" + this.form.id).then(result => {
                    this.$utils.merge(this.form, result);
                })
            }
        },
        methods: {
            submit() {
                let url = this.form.id > 0 ? "/sensitives/edit" : "/sensitives/save";
                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$router.go(-1);
                }, (data) => {
                    this.errors = data;
                });
            },
            close() {
                this.$router.go(-1);
            },
            changeLevel(val) {
                if (val === "global") {
                    this.form.code = "";
                }
            }
        }
    }
</script>